import { render, staticRenderFns } from "./RsaPazienteStampeComponent.vue?vue&type=template&id=6949762a&scoped=true"
import script from "./RsaPazienteStampeComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteStampeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6949762a",
  null
  
)

export default component.exports